import AppHeader from '../AppHeader'
let utils = require('../../utils')
export default {
  name: 'referral',
  created () {
    this.shopId = localStorage.shop_id
    this.getShopALL()
    this.getReferrals()
  },
  data () {
    return {
      getShopAllEnd: false,
      searchCallbackFlag: false,
      referrals: [],
      referral: '',
      shopId: '',
      referralId: '',
      shops: '',
      friendEmail: '',
      message: '',
      sendBottonFlag: true,
      savingFlag: false
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    getShopALL: function () {
      this.$store.dispatch('GET_SHOP_ALL')
      .then(res => {
        this.shops = res
        this.getShopAllEnd = true
      })
    },
    getReferrals: function () {
      this.searchCallbackFlag = false
      this.$store.dispatch('GET_REFERRAL', {shop_id: this.shopId})
      .then(res => {
        this.referrals = res.data
        this.searchCallbackFlag = true
      })
      .catch(err => console.log(err))
    },
    shopChange: function () {
      this.referrals = []
      this.referral = ''
      this.referralId = ''
      this.getReferrals()
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    displayReferral: function (referralId) {
      for (let key in this.referrals) {
        if (this.referrals[key].id === referralId) {
          this.referral = this.referrals[key]
          return
        }
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    isInputEmail: function () {
      if (utils.isBlank(this.friendEmail)) {
        return false
      }
      if (!utils.isEmail(this.friendEmail)) {
        return false
      }
      return true
    },
    sendLine: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      let sendUrl = location.href
      sendUrl = sendUrl.substr(0, sendUrl.lastIndexOf('#')) + '#/introduction/'
      let data = {
        user_id: window.localStorage.getItem('user_id'),
        referral_id: this.referral.id,
        shop_id: this.shopId,
        url: sendUrl
      }
      self = this
      let callback = function (url) {
        self.savingFlag = false
        let ua = navigator.userAgent.toLowerCase()
        // safariの場合
        if ((ua.indexOf('safari') > -1) && (ua.indexOf('chrome') == -1)) {
          location.href = 'line://msg/text/?' + encodeURIComponent(url)
        } else {
          window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`, '_blank')
        }
      }
      this.$store.dispatch('INTRODUCTION_CREATE', {data: data})
      .then(res => {
        callback(res)
      })
      .catch(err => console.log(err))
    },
    sendEmail: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      if (!this.friendEmail) {
        this.message = 'メールアドレスを入力してください'
        return
      }
      let sendUrl = location.href
      sendUrl = sendUrl.substr(0, sendUrl.lastIndexOf('#')) + '#/introduction/'
      let data = {
        user_id: window.localStorage.getItem('user_id'),
        referral_id: this.referral.id,
        shop_id: this.shopId,
        url: sendUrl,
        friend_email: this.friendEmail
      }
      this.$store.dispatch('INTRODUCTION_CREATE', {data: data})
      .then(res => {
        this.message = 'メール送信しました'
        this.sendBottonFlag = false
        this.savingFlag = false
      })
      .catch(err => console.log(err))
    },
    reload: function () {
      location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/referral.js